import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAlert,
  FDStack,
  Table,
} from '@facet-wealth/design';
import TableBody from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Table/TableBody';
import NonAUMItemRow from './NonAUMItemRow';

const FacetPlanNextUpNonAUMLayout = ({ collection }) => {
  if (collection.resources().length() === 0) {
    return <FDAlert status="info" title="There are no non-aum items for this scenario." />;
  }

  return (
    <FDStack direction="column" spacing={2} alignItems="flex-start" justifyContent="flex-start">
      <Table.Table>
        <Table.HeadColumnHeaderSet>
          {collection.meta().template().list()
            .map((field) => (
              <Table.HeadColumnHeaderCell
                key={field.attr('name')}
                variant={'head'}
                value={field.attr('prompt')}
              />
            ))}
        </Table.HeadColumnHeaderSet>
        <TableBody>
          {collection.resources().list().map((itemResource) => (
            <NonAUMItemRow key={itemResource.id()} resource={itemResource} />
          ))}
        </TableBody>
      </Table.Table>
    </FDStack>
  );
};

FacetPlanNextUpNonAUMLayout.propTypes = {
  collection: PropTypes.object.isRequired,
};

FacetPlanNextUpNonAUMLayout.defaultProps = {
};

export default FacetPlanNextUpNonAUMLayout;
